import MeidouInfoBtn from '@meitu/xdesign-widgets/dist/meidouInfo/compoments/meidouInfoBtn';
import { UserInfoType } from '@meitu/xdesign-widgets/dist/types/userInfo';
import { useUserInfoHelper } from '@/editor/header/components/user-info/hooks/use-user-info-helper';
import { isIntl } from '@/react-process-env';
import { useStoreState } from '@/store';
import { Entrance } from '@/types';
import { jumpToLogin, openVipModal } from '@/utils/login';

const AIMeidouBtn: React.FC = () => {
    const { showUserInfo } = useUserInfoHelper();

    const { meidouInfo } = useStoreState((state) => state.meidouModel);
    const userInfo = showUserInfo() as UserInfoType;

    return (
        <>
            {/* 国内版才展示 美豆按钮 */}
            {!isIntl && (
                <MeidouInfoBtn
                    meidouInfo={meidouInfo}
                    onClick={() => {
                        if (userInfo?.id) {
                            const newParams = {
                                default_tab: userInfo?.is_vip ? 'meidou' : 'sub',
                                entrance: Entrance.ToolPanel,
                                sku_type: userInfo?.is_vip ? 1 : 2,
                                user_type: userInfo?.is_vip ? 1 : 0,
                            };
                            openVipModal({
                                categoryGroupCode: userInfo?.is_vip
                                    ? 'mtxxpc.purchase.group.default.meidou'
                                    : 'mtxxpc.purchase.group.default.scribe',
                                subscribe_type: 'meidou',
                                ...newParams,
                            });
                        } else {
                            jumpToLogin();
                        }
                    }}
                    style={{
                        height: 26,
                        padding: `0 8px 0 4px`,
                    }}
                ></MeidouInfoBtn>
            )}
        </>
    );
};

export default AIMeidouBtn;
